// /local-feature
import React from 'react';
import ProductPage from './ProductPage';
import local_header from '../../assets/images/unauth/local-feature-header.jpg';
import local_poster from '../../assets/images/unauth/local-feature-poster.jpg';
import local_timestamps from '../../assets/images/unauth/local-feature-timestamps.jpg';
import local_chat from '../../assets/images/unauth/local-feature-chat.jpg';

const LocalFeature = () => (
  <ProductPage
    path="/local-feature"
    seo={{
      title: 'AI Analyze Your Local Videos | Bumpups.com',
      description: 'Process and analyze local video files with Bumpups’ AI. MP4, MOV or WebM up to 16 GB in SD, HD or 4K – get AI timestamps, then chat with your video for summaries and insights.',
    }}
    hero={{
      title: 'Any local video',
      subtitle: 'Bumpups streamlines your workflow by processing local video files, supporting a wide range of formats and quality levels.',
      note: 'Local uploads are part of the Pro plan.',
      image: local_header,
      imageAlt: 'A video file being dragged onto Bumpups to upload',
      width: 1400,
      height: 950,
    }}
    workflow={{
      title: 'Your local video workflow',
      description: 'Handle every type of local video file with ease. Upload files effortlessly and enjoy seamless processing along with detailed insights.',
      video: '/media/local-feature.mp4',
      poster: local_poster,
      features: [
        { title: 'Upload & process videos', text: 'Upload any local video file effortlessly with Bumpups. Our system supports a wide range of formats and quality levels.' },
        { title: 'Integrated video insights', text: 'Get AI timestamps automatically, then chat with the video for summaries, answers, and more.' },
        { title: 'Video specifications', text: 'MP4, MOV or WebM files up to 16 GB, in SD, HD or 4K, with 16:9 or 9:16 aspect ratios.' },
      ],
    }}
    rows={[
      {
        title: 'Timestamps for every upload',
        text: 'Bump AI chapters every video you upload, from recorded meetings to lectures, so you can jump straight to the moment you need.',
        cta: 'Try it out',
        image: local_timestamps,
        alt: 'An uploaded team meeting in Bumpups with its AI-generated timestamps',
      },
      {
        title: 'Ask Bump AI anything',
        text: 'Bump AI can generate tables, bullet points, checklists, email drafts, summaries, scripts, lecture notes, quiz questions, SWOT analyses, and more about your video content, and it remembers the conversation so you can follow up.',
        cta: 'Try it out',
        image: local_chat,
        alt: 'Bump AI listing the three Q4 priorities from an uploaded meeting, with timestamps',
      },
    ]}
  />
);

export default LocalFeature;
